import { type MessageInstance } from "antd/es/message/interface";

import { privateAPI } from "../../../_config/constants";
import { errorHandler } from "../../_utils";
import { store, type SubCategoryFormType } from "..";
import {
  setSubCategories,
  setSubCategoryLoading,
} from "../slices/subCategorySlice";

export const getSubcategories = async (notify: MessageInstance) => {
  try {
    store.dispatch(setSubCategoryLoading(true));
    const response = await privateAPI.get("/sub-category");
    if (response) {
      store.dispatch(setSubCategoryLoading(false));
      store.dispatch(setSubCategories(response.data));
    }
    return response;
  } catch (error) {
    store.dispatch(setSubCategoryLoading(false));
    console.error("Get Subcategory Error:", error);
    errorHandler(error, notify);
  }
};

export const createSubcategory = async (
  notify: MessageInstance,
  payload: SubCategoryFormType,
) => {
  try {
    store.dispatch(setSubCategoryLoading(true));
    const params = payload.parentId
      ? `/sub-category?parentId=${payload.parentId}`
      : "/sub-category";
    const { data } = await privateAPI.post(params, payload);
    notify.success("Subcategory created successfully!");
    return data;
  } catch (error) {
    console.error("Create Subcategory Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setSubCategoryLoading(false));
  }
};

export const updateSubcategory = async (
  notify: MessageInstance,
  payload: SubCategoryFormType,
) => {
  try {
    if (!payload.id) return;
    store.dispatch(setSubCategoryLoading(true));
    const params = payload.parentId
      ? `/sub-category/${payload.id}?parentId=${payload.parentId}`
      : `/sub-category/${payload.id}`;
    const { data } = await privateAPI.put(params, payload);
    notify.success("Subcategory updated successfully!");
    return data;
  } catch (error) {
    console.error("Update Subcategory Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setSubCategoryLoading(false));
  }
};

export const deleteSubcategory = async (
  notify: MessageInstance,
  id: string,
  getData = false,
) => {
  try {
    store.dispatch(setSubCategoryLoading(true));
    const response = await privateAPI.delete(`/sub-category/${id}`);
    if (response) {
      getData && (await getSubcategories(notify));
    }
    notify.success("Subcategory deleted successfully!");
    return response;
  } catch (error) {
    console.error("Delete Subcategory Error:", error);
    errorHandler(error, notify);
  } finally {
    store.dispatch(setSubCategoryLoading(false));
  }
};
